// Speed optimization script
(function () {
  // Execute immediately but safely
  safeExecute(optimizePageLoad);

  // Run again when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      safeExecute(optimizePageLoad);
    });
  } else {
    safeExecute(optimizePageLoad);
  }

  // Run once more when page is fully loaded
  window.addEventListener("load", function () {
    safeExecute(optimizePageLoad);
  });

  // Safely execute functions with error handling
  function safeExecute(fn) {
    try {
      fn();
    } catch (e) {
      console.log("Error in speed optimizer:", e);
    }
  }

  function optimizePageLoad() {
    // Set page as interactive immediately
    if (document.documentElement) {
      document.documentElement.style.setProperty(
        "--mobile-page-load-state",
        "ready"
      );
    }

    // Force-enable all interaction - only if body exists
    if (document.body) {
      document.body.style.pointerEvents = "auto";
    }

    // Fix failed script loads that might block the UI
    handleFailedScripts();

    // Ensure menu is accessible - wait for DOM to be ready
    if (document.readyState !== "loading") {
      makeMenuAccessible();
      removeLoadingStates();
    } else {
      // If DOM not ready, wait for it
      document.addEventListener("DOMContentLoaded", function () {
        makeMenuAccessible();
        removeLoadingStates();
      });
    }
  }

  function handleFailedScripts() {
    // Check for common script load failures
    var scriptLoadTimeout = setTimeout(function () {
      // If TrustReviews hasn't loaded after 2 seconds, create a dummy object
      if (typeof window.TrustReviews === "undefined") {
        console.log("Creating TrustReviews fallback");
        window.TrustReviews = {
          init: function () {
            console.log("TrustReviews fallback init called");
            return null;
          },
        };
      }

      // If Shopify captcha exists, wrap it safely without redefining properties
      if (window.Shopify && window.Shopify.captcha) {
        try {
          // Create a safe wrapper for the captcha object
          var originalCaptcha = window.Shopify.captcha;
          var safeProtect = function () {
            try {
              if (originalCaptcha && originalCaptcha.protect) {
                return originalCaptcha.protect.apply(
                  originalCaptcha,
                  arguments
                );
              }
              return null;
            } catch (e) {
              console.log("Captcha error safely handled");
              return null;
            }
          };

          // Only assign if the property isn't already defined
          if (!window.Shopify.captcha.protect) {
            window.Shopify.captcha.protect = safeProtect;
          }
        } catch (e) {
          console.log("Error handling captcha:", e);
        }
      }
    }, 2000);
  }

  function makeMenuAccessible() {
    // Ensure menu buttons are clickable - with error handling
    try {
      var menuElements = document.querySelectorAll(
        '.header__icon, .header__menu-item, [data-action="open-drawer"]'
      );

      if (menuElements && menuElements.length > 0) {
        menuElements.forEach(function (element) {
          if (element) {
            element.style.pointerEvents = "auto";
            element.style.cursor = "pointer";
            element.style.touchAction = "manipulation";

            // Add high z-index to ensure they're clickable
            element.style.position = "relative";
            element.style.zIndex = "100";
          }
        });
      }
    } catch (e) {
      console.log("Error making menu accessible:", e);
    }
  }

  function removeLoadingStates() {
    try {
      var loadingElements = document.querySelectorAll(
        '[aria-busy="true"], [loading="true"], .is-loading'
      );

      if (loadingElements && loadingElements.length > 0) {
        loadingElements.forEach(function (element) {
          if (element) {
            element.removeAttribute("aria-busy");
            element.removeAttribute("loading");
            if (element.classList) {
              element.classList.remove("is-loading");
            }
          }
        });
      }
    } catch (e) {
      console.log("Error removing loading states:", e);
    }
  }
})();
